// extracted by mini-css-extract-plugin
module.exports =  {"btn-spacer":"_32bbee5fda--btn-spacer--wRzGk"};